// Slick Sliders
(function($){
    var blockLoaded = false;
    var blockLoadedInterval = setInterval(function() {
        if (document.getElementById('reviewSlider')) {
            $('#reviewSlider').slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 750,
                dots: false,
                arrows: false,
                prevArrow:"<button class='slick-btn-wrap slick-btn-left' type='button'><span class='slick-purple-btn'><i class='fas fa-chevron-left'></i></span></button>",
                nextArrow:"<button class='slick-btn-wrap slick-btn-right' type='button'><i class='fas fa-chevron-right'></i></i></button>",
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                margin:10,
                pauseOnHover:false,
                
            });
            blockLoaded = true;
        }
        
        if ( blockLoaded ) {
            clearInterval( blockLoadedInterval );
        }
    }, 500);
})(jQuery);